import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
gsap.registerPlugin(SplitText);

export default class FrontpageHero {
	constructor() {
		const hero = document.querySelector('.front--page__hero');

		if (hero) {
			const hero_heading = hero.querySelector('.front--page__hero__heading');
			const hero_text = hero.querySelector('.front--page__hero__text');
			const hero_mobile_text = hero.querySelector('.front--page__hero__mobile-text');
			// const hero_image = hero.querySelector('.front--page__hero__image');
			const hero_animation = hero.querySelector('.front--page__hero__animated-gif');

			var tl = gsap.timeline({});

			var text = new SplitText(hero_heading, { type: 'words,chars' });
			var headingChars = text.chars;

			gsap.set(hero_heading, { perspective: 400 });

			window.addEventListener('load', (event) => {
				tl.to(
					hero,
					{
						visibility: 'visible',
						opacity: 1,
					},
					'<'
				);
			});
			// tl.from(
			// 	hero_image,
			// 	{
			// 		duration: 1,
			// 		ease: 'expoScale(0.5,7,power1.out)',
			// 		// y: 20,
			// 		scale: 0.7,
			// 		delay: 0.35,
			// 		opacity: 0,
			// 	},
			// 	'<'
			// );
			if (headingChars) {
				tl.from(
					headingChars,
					{
						duration: 1,
						y: 20,
						opacity: 0,
						ease: 'expo.out',
						// scale: 0,
					},
					'.5'
				);
			}
			if (hero_text) {
				tl.from(
					hero_text,
					{
						duration: 1,
						y: 24,
						opacity: 0,
						ease: 'expo.out',
					},
					'.6'
				);
			}
			if (hero_mobile_text) {
				tl.from(
					hero_mobile_text,
					{
						duration: 1,
						y: 20,
						opacity: 0,
						ease: 'expo.out',
					},
					'.5'
				);
			}
			if (hero_animation) {
				tl.to(
					hero_animation,
					{
						duration: 2.5,
						ease: 'power1.outIn',
						clipPath: 'polygon(0 0, 0 100%, 100% 100%, 100% 0)',
						opacity: 1,
					},
					'.35'
				);
			}
		}
	}
}
